{
  "version": 1,
  "asset_id": "4d97ef60-21e9-431d-84db-fc398a17177e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4d97ef60-21e9-431d-84db-fc398a17177e/ind-healthcare-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4d97ef60-21e9-431d-84db-fc398a17177e/ind-healthcare-1200.avif",
  "original_filename": "ind-healthcare-1200.avif",
  "size": 7788,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:01Z"
}
